import withAnalytics from './utilities/withAnalytics';

import App from './App.jsx';
import About from './pages/About.jsx';
import Persona from './pages/Persona.jsx';

const routes: Routes = [
  {
    component: withAnalytics(App),
    routes: [
      {
        path: '/about',
        component: About,
        exact: true,
      },
      {
        path: '/:id',
        component: Persona,
        exact: true,
      },
      {
        path: '/:id/:key',
        component: Persona,
        exact: true,
      },
      {
        path: '/',
        component: Persona,
        exact: true,
      },
      // {
      //   path: '*',
      //   component: NotFound,
      // },
    ]
  }
];

export default routes;



// WEBPACK FOOTER //
// ./client/routes.js